import React, { useState, useEffect, useRef, useMemo } from "react";
import { addDays, format } from "date-fns";
import { FaBed, FaCalendarAlt, FaUser } from "react-icons/fa";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "./searchForm.css";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import { FiInstagram, FiFacebook, FiSend, FiMenu, FiX } from "react-icons/fi";
import { safeString } from "../utils/langUtils";
import {
  Instagram,
  Facebook,
  Send,
  Menu,
  X,
  MapPin
} from "lucide-react";
import ScrollNavbar from "./ScrollNavbar";
import { normalizeAvailability } from "../utils/normalizeAvailability";
import SearchAvailabilityCalendar from "../components/SearchAvailabilityCalendar";

export default function SearchForm() {
  const location = useLocation();
  const [destination, setDestination] = useState("Dubai, UAE");
  const [apartments, setApartments] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [selectedApartment, setSelectedApartment] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [openCalendar, setOpenCalendar] = useState(false);
  const dropdownRef = useRef();
  const calendarRef = useRef();
  const isMobile = window.innerWidth < 768;
  const navigate = useNavigate();
 const [menuOpen, setMenuOpen] = useState(false);
 const [showNavbar, setShowNavbar] = useState(false);
  const [checkIn, setCheckIn] = useState(null);      // ✅ new
  const [checkOut, setCheckOut] = useState(null);    // ✅ new
  const [totalPrice, setTotalPrice] = useState(0);   // ✅ new
  const [packages, setPackages] = useState([]);
  const [filteredPackages, setFilteredPackages] = useState([]);

 


 //==========Calender price show==========
const [rateData, setRateData] = useState({});
const [loadingRates, setLoadingRates] = useState(false);
// If user selected apartment → use that, else Bahar
const activeApartmentId = selectedApartment?.id || 3028791;
const aptRates = rateData?.[String(activeApartmentId)] || {};

useEffect(() => {
  const fetchData = async () => {
    const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:4000";
    try {
      const res = await fetch(`${API_BASE}/api/apartments`);
      const data = await res.json();

      const rawArray = Array.isArray(data) ? data : 
                       Array.isArray(data?.apartments) ? data.apartments : 
                       Array.isArray(data?.data?.apartments) ? data.data.apartments : [];

      // ✅ 2. Industry Standard: Normalize the names immediately
      const normalizedData = rawArray.map(apt => ({
        ...apt,
        name: safeString(apt.name), // Ensures name is a string
        city: safeString(apt.city)   // Ensures city is a string
      }));

      setApartments(normalizedData);
    } catch (err) {
      console.error("Fetch failed", err);
    }
  };
  fetchData();
}, []);


const lowestPrice = useMemo(() => {
  const prices = Object.values(aptRates)
    .map(d => d?.price)
    .filter(p => typeof p === "number");

  return prices.length ? Math.min(...prices) : null;
}, [aptRates]);

const renderDayContent = (day) => {
  const dateKey = format(day, "yyyy-MM-dd");
  const dayData = aptRates[dateKey];

  const isBestPrice =
    typeof dayData?.price === "number" &&
    lowestPrice !== null &&
    dayData.price === lowestPrice;

    

    //REset Form
    const resetForm = () => {
    setDestination("Dubai, UAE");
    setSelectedApartment(null);
    setFiltered([]);
    setOpenCalendar(false);
    setOpenGuests(false);

    setDateRange([
      {
        startDate: new Date(),
        endDate: addDays(new Date(), 1),
        key: "selection",
      },
    ]);

    setGuests({
      adults: 2,
      children: 0,
      rooms: 1,
      pets: false,
    });
  };

  


  return (
    <div className="rdr-day-inner">
      {/* Date */}
      <div className="rdr-day-date">
        {format(day, "d")}
      </div>

      {/* Price */}
      {typeof dayData?.price === "number" && (
        <div
          className={`rdr-day-price ${
            isBestPrice ? "rdr-best-price" : ""
          }`}
        >
          AED {dayData.price.toLocaleString()}
        </div>
      )}
    </div>
  );
};

//==========Calender price show end==========




  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 1),
      key: "selection"
    }
  ]);
const [openGuests, setOpenGuests] = useState(false);
const guestsRef = useRef();

const [guests, setGuests] = useState({
  adults: 2,
  children: 0,
  rooms: 1,
  pets: false
});


// ✅ RESET FUNCTION (ONE PLACE ONLY)
  const resetForm = () => {
    setDestination("Dubai, UAE");
    setSelectedApartment(null);
    setFiltered([]);
    setOpenCalendar(false);
    setOpenGuests(false);

    setDateRange([
      {
        startDate: new Date(),
        endDate: addDays(new Date(), 1),
        key: "selection",
      },
    ]);

    setGuests({
      adults: 2,
      children: 0,
      rooms: 1,
      pets: false,
    });
  };

  useEffect(() => {
  if (location.pathname === "/") {
    resetForm();
  }
}, [location.pathname]);


useEffect(() => {
  const fetchData = async () => {
    // const API_BASE = process.env.REACT_APP_API_URL;
    const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:4000";



    const res = await fetch(`${API_BASE}/api/apartments`);
    const data = await res.json();

    // ✅ Force correct array form
    const apartmentsArray =
      Array.isArray(data) ? data :
      Array.isArray(data?.apartments) ? data.apartments :
      Array.isArray(data?.data?.apartments) ? data.data.apartments :
      [];

    setApartments(apartmentsArray);
  };

  fetchData();
}, []);

useEffect(() => {
  if (!destination.trim()) {
    return setFiltered([]);
  }

  const lower = destination.toLowerCase();

  const match = [
    ...apartments
  ].filter((a) => { // <--- ✅ Add curly brace here
    // ✅ Use safeString to convert objects to strings before calling .toLowerCase()
    const cityName = safeString(a.city).toLowerCase();
    const propertyName = safeString(a.name).toLowerCase();

    return cityName.includes(lower) || propertyName.includes(lower);
  }); // <--- ✅ Add closing curly brace here

  setFiltered(match);
}, [destination, apartments]);



//========Packages=========
useEffect(() => {
  const fetchPackages = async () => {
    const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:4000";
    try {
      const res = await fetch(`${API_BASE}/api/packages`);
      const data = await res.json();
      const packagesArray = Array.isArray(data)
        ? data
        : Array.isArray(data?.packages)
        ? data.packages
        : Array.isArray(data?.data?.packages)
        ? data.data.packages
        : [];
      setPackages(packagesArray);
    } catch (err) {
      console.error("Fetch packages failed", err);
    }
  };
  fetchPackages();
}, []);

useEffect(() => {
  if (!destination.trim()) return setFilteredPackages([]);

  const lower = destination.toLowerCase();

  const match = packages.filter((pkg) => {
    const pkgName = safeString(pkg.name).toLowerCase();
    return pkgName.includes(lower);
  });

  setFilteredPackages(match);
}, [destination, packages]);


//Hero Video 
// useEffect(() => {
//   const onScroll = () => {
//     const nav = document.querySelector(".mobile-nav");
//     if (!nav) return;

//     if (window.scrollY > 40) {
//       nav.classList.add("scrolled");
//     } else {
//       nav.classList.remove("scrolled");
//     }
//   };

//   onScroll(); // run once on load
//   window.addEventListener("scroll", onScroll);
//   return () => window.removeEventListener("scroll", onScroll);
// }, []);

useEffect(() => {
  const onScroll = () => {
    setShowNavbar(window.scrollY > 80);
  };

  window.addEventListener("scroll", onScroll);
  onScroll();

  return () => window.removeEventListener("scroll", onScroll);
}, []);



// ✅ Close dropdown when click outside
useEffect(() => {
  const handler = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setFiltered([]);
    }
  };

  document.addEventListener("mousedown", handler);
  return () => document.removeEventListener("mousedown", handler);
}, []);


//Calender Close Effect
useEffect(() => {
  const handleOutsideClick = (e) => {
    if (calendarRef.current && !calendarRef.current.contains(e.target)) {
      setOpenCalendar(false);
      // setSelectingEnd(false);
    }
  };

  if (openCalendar) {
    document.addEventListener("mousedown", handleOutsideClick);
  }

  return () => {
    document.removeEventListener("mousedown", handleOutsideClick);
  };
}, [openCalendar]);




//Guest Handler 
useEffect(() => {
  const handleOutsideGuests = (e) => {
    if (guestsRef.current && !guestsRef.current.contains(e.target)) {
      setOpenGuests(false);
    }
  };

  if (openGuests) {
    document.addEventListener("mousedown", handleOutsideGuests);
  }

  return () => {
    document.removeEventListener("mousedown", handleOutsideGuests);
  };
}, [openGuests]);


// const handleSearch = async () => {
//     if (!dateRange[0].endDate) {
//       alert("Please select checkout date");
//       return;
//     }

//     const payload = {
//       arrivalDate: format(dateRange[0].startDate, "yyyy-MM-dd"),
//       departureDate: format(dateRange[0].endDate, "yyyy-MM-dd"),
//     };

//     const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:4000";

//     // 🔴 WAS: fetch(`${API_BASE}/api/check-availability`...
//     // ✅ FIX: Update to /api/rates/check-availability
//     try {
//       const res = await fetch(`${API_BASE}/api/rates/check-availability`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload)
//       });

//       const data = await res.json();

//       const params = new URLSearchParams({
//         dest: destination || "All locations",
//         arrival: payload.arrivalDate,
//         departure: payload.departureDate,
//         adults: String(guests.adults || 0),
//         children: String(guests.children || 0),
//         rooms: String(guests.rooms || 1),
//         pets: String(Boolean(guests.pets)),
//       });

//       navigate(`/results?${params.toString()}`, {
//         state: {
//           availability: data, 
//         },
//       });
//     } catch (error) {
//       console.error("Search failed", error);
//       // Navigate anyway so user sees results (logic in Results.js will retry)
//       // ... navigation code ...
//     }
//   };


const handleSearch = async () => {
 if (!checkOut) {
    alert("Please select checkout date");
    return;
  }

  const payload = {
    arrivalDate: format(checkIn, "yyyy-MM-dd"),
    departureDate: format(checkOut, "yyyy-MM-dd"),
  };

  const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:4000";

  try {
    const res = await fetch(`${API_BASE}/api/rates/check-availability`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    const params = new URLSearchParams({
      dest: destination || "All locations",
      arrival: payload.arrivalDate,
      departure: payload.departureDate,
      adults: String(guests.adults || 0),
      children: String(guests.children || 0),
      rooms: String(guests.rooms || 1),
      pets: String(Boolean(guests.pets)),
    });

    navigate(`/results?${params.toString()}`, {
      state: { availability: data },
    });
  } catch (error) {
    console.error("Search failed", error);
  }
};


  return (
<>
<ScrollNavbar visible={showNavbar} />
     <div className="hero-section">
      <div className="video-bg">
      <video autoPlay muted loop playsInline className="video">
        <source src="/assets/videos/video.mp4" type="video/mp4" />
      </video>
    </div>

    <div className="hero-wrapper">
      {/* === MOBILE NAVBAR (only visible on phones) === */}
      {/* Overlay behind menu */}
    <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
      <div style={{ textAlign: "right", marginBottom: 20 }}>
        <X className="icon-close" onClick={() => setMenuOpen(false)} />
      </div>

    <nav className="flex flex-col mt-1">

      <NavLink
        to="/"
        onClick={() => setMenuOpen(false)}
        className="menu-item"
      >
        Home
      </NavLink>

      <NavLink
        to="/stays"
        onClick={() => setMenuOpen(false)}
        className="menu-item"
      >
        Stays
      </NavLink>

      <NavLink
        to="/flights"
        onClick={() => setMenuOpen(false)}
        className="menu-item"
      >
        Flights
      </NavLink>

      <NavLink
        to="/cars"
        onClick={() => setMenuOpen(false)}
        className="menu-item"
      >
        Car Rentals
      </NavLink>

    </nav>




      <div style={{ marginTop: 30, textAlign: "center" }}>
        <div className="mobile-social">
            <Instagram className="w-6 h-6 text-slate-700 hover:text-pink-600 transition" />
            <Facebook className="w-6 h-6 text-slate-700 hover:text-blue-600 transition" />
            <Send className="w-6 h-6 text-slate-700 hover:text-blue-500 transition" />
        </div>
      </div>
    </div>

    <div className="hero">

        <div className="header-center">
          <h1>Find your next stay</h1>
          <p>Search deals on hotels, homes, and much more…</p>
        </div>


      <div className="search-bar">

        {/* Destination */}
        <div className="box" ref={dropdownRef}>
          <FaBed className="icon" />
          <input
            type="text"
            placeholder="Where are you going?"
            value={destination}
            onChange={(e) => {
              setDestination(e.target.value);
              setSelectedApartment(null);
            }}
          />

          {filtered.length > 0 && (
            <div className="dropdown">
              {filtered.map((apt) => (
                <div
                  key={`${apt.id}-${safeString(apt.name)}`} // ✅ use safeString for key
                  onClick={() => {
                    setDestination(`${safeString(apt.name)}, ${safeString(apt.city) || "Dubai"}`); // ✅ safeString here
                    setSelectedApartment({
                      ...apt,
                      id: apt.smoobuId ?? apt.id,
                    });
                    setFiltered([]);
                  }}
                  className="flex items-center gap-3 p-3 cursor-pointer hover:bg-gray-100 transition border-b"
                >
                  <MapPin className="w-4 h-4 text-blue-600 flex-shrink-0" />

                  <div className="flex flex-col">
                    <span className="font-medium text-sm md:text-base">
                      {safeString(apt.name)} {/* ✅ safeString here */}
                    </span>
                    <span className="text-xs text-gray-500">
                      {safeString(apt.city)} {/* ✅ safeString here */}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}


        </div>



        {/* Date Picker */}
        {/* Date Picker Input */}
        <div className="box relative" onClick={() => setOpenCalendar(true)}>
          <FaCalendarAlt className="icon" />
          <span>
            {checkIn
              ? checkOut
                ? `${format(checkIn, "MMM dd")} → ${format(checkOut, "MMM dd")}`
                : `${format(checkIn, "MMM dd")} → Select checkout`
              : "Select dates"}
          </span>

          {openCalendar && ( 
            <div
              className="absolute z-50 top-full left-0 mt-2 w-full bg-white shadow-lg rounded-lg"
              ref={calendarRef}
            >
<SearchAvailabilityCalendar
  type={selectedApartment ? "apartment" : selectedPackage ? "package" : "apartment"} // Default to apartment
  apartment={selectedApartment}
  apartmentId={selectedApartment?.id}
  pkg={selectedPackage}
  // Convert dates to strings so the calendar can highlight them correctly
  checkIn={checkIn ? format(checkIn, "yyyy-MM-dd") : ""}
  checkOut={checkOut ? format(checkOut, "yyyy-MM-dd") : ""}
  onChange={(data) => {
    setCheckIn(data.checkIn);
    setCheckOut(data.checkOut);
    setTotalPrice(data.totalPrice || 0);

    if (data.closeCalendar) {
      setOpenCalendar(false); // This hides the modal
    }
  }}
/>

            </div>
          )}
        </div>

        {/* Guests */}
        <div
          className="box static"
          onClick={() => setOpenGuests(true)}
        >
          <FaUser className="icon" />
          <span>
            {guests.adults} adults · {guests.children} children · {guests.rooms} room
          </span>

          {openGuests && (
            <div className="guests-modal" 
            ref={guestsRef}
            onClick={(e) => e.stopPropagation()}
            >
              
              <div className="row">
                <span>Adults</span>
                <div className="counter">
                      <button
                        disabled={guests.adults === 1}
                        onClick={(e) => {
                          e.stopPropagation();
                          setGuests({ ...guests, adults: guests.adults - 1 });
                        }}
                      >
                        −
                      </button>

                  <span>{guests.adults}</span>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setGuests({ ...guests, adults: guests.adults + 1 });
                        }}
                      >
                        +
                      </button>
                </div>
              </div>

              <div className="row">
                <span>Children</span>
                <div className="counter">
                    <button
                      disabled={guests.children === 0}
                      onClick={(e) => {
                        e.stopPropagation();
                        setGuests({ ...guests, children: guests.children - 1 });
                      }}
                    >
                      −
                    </button>
                  <span>{guests.children}</span>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setGuests({ ...guests, children: guests.children + 1 });
                      }}
                    >
                      +
                    </button>
                </div>
              </div>

              <div className="row">
                <span>Rooms</span>
                <div className="counter">
                  <button
                    disabled={guests.rooms === 1}
                    onClick={() =>
                      setGuests({ ...guests, rooms: guests.rooms - 1 })
                    }
                  >−</button>
                  <span>{guests.rooms}</span>
                  <button
                    onClick={() =>
                      setGuests({ ...guests, rooms: guests.rooms + 1 })
                    }
                  >+</button>
                </div>
              </div>

              <div className="pets">
                <span>Traveling with pets?</span>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={guests.pets}
                    onChange={(e) => {
                      e.stopPropagation();
                      setGuests({ ...guests, pets: !guests.pets });
                    }}
                  />

                  <span className="slider"></span>
                </label>
              </div>

              <button
                className="done-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenGuests(false);
                }}
              >
                Done
              </button>


            </div>
          )}
        </div>


        {/* Search */}
        <button className="search-btn" onClick={handleSearch}>
          Search
        </button>

      </div>
    </div>

    </div>
    </div>
    </>
  );
}